@if (loading) {
  <div class="chart-skeleton"></div>
} @else if (dataPoints.length > 0) {
  <apx-chart
    #chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [dataLabels]="chartOptions.dataLabels"
    [stroke]="chartOptions.stroke"
    [markers]="chartOptions.markers"
    [tooltip]="chartOptions.tooltip"
    [fill]="chartOptions.fill"
    [grid]="chartOptions.grid"></apx-chart>
}
